module.exports = __webpack_public_path__ + "static/Megazone-092c605459565a43723a6bb932772c15.mp4";